export const Vial = ({ code = "AP-01", pid = "retatrutide", className = "", glow = true }) => (
  <div className={`relative ${className}`} data-testid={`vial-${code.toLowerCase()}`}>
    {glow && (
      <div className="absolute -inset-10 rounded-full bg-[#6E7683]/25 blur-3xl pointer-events-none" />
    )}
    <div className="relative overflow-hidden rounded-2xl border border-white/10 shadow-[0_24px_60px_-12px_rgba(110,118,131,0.45)]">
      <img
        src={`/assets/products/${pid}.webp`}
        alt={`Alpha Peps ${code} research vial`}
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        loading="lazy"
        onError={(e) => { e.currentTarget.src = "/assets/product.webp"; }}
      />
      <div className="absolute bottom-3 left-3 rounded-md border border-white/15 bg-[#08080A]/85 px-2.5 py-1 font-mono text-[9px] tracking-[0.2em] text-[#E8E9EB] backdrop-blur-sm">
        {code}
      </div>
    </div>
  </div>
);
